module.exports = __webpack_public_path__ + "static/media/027.849c90c4.jpg";